import { GenericError } from '@cian/peperrors/shared';
export class CircuitBreakerError extends GenericError {
    constructor(api) {
        super({ type: 'CircuitBreakerError', domain: 'http-api.circuit-breaker', message: api });
        Object.setPrototypeOf(this, CircuitBreakerError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CircuitBreakerError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
//# sourceMappingURL=circuitBreakerError.js.map